import { customerAuthSession } from './customerAuthSession';

export const getAccessToken = (): Promise<string | null> =>
  customerAuthSession.getAccessToken();
